import { render, staticRenderFns } from "./commonPage.vue?vue&type=template&id=73eca46a"
import script from "./commonPage.vue?vue&type=script&lang=js"
export * from "./commonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports